import { render, staticRenderFns } from "./AppNavbarVerticalLayout.vue?vue&type=template&id=659d4088&scoped=true&"
import script from "./AppNavbarVerticalLayout.vue?vue&type=script&lang=js&"
export * from "./AppNavbarVerticalLayout.vue?vue&type=script&lang=js&"
import style0 from "./AppNavbarVerticalLayout.vue?vue&type=style&index=0&id=659d4088&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "659d4088",
  null
  
)

export default component.exports